module.exports = __webpack_public_path__ + "img/GS.92870e61.svg";